export default __webpack_public_path__ + "static/Hillary_Jade-021059018c218deb873990940aabb0b7.jpg";